import { Injectable, NgZone } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';
import { Store } from '@ngrx/store';

import { ToastrService } from 'ngx-toastr';
import { NotfGravity } from '@apps/notf/models/message';
import { Message } from '@apps/notf/models/message';
import { IAuroraState } from '@apps/aurora.state';
import * as fromNotfStore from '@apps/notf/store';

import { NotifType } from '../enum/notif-type.enum';

@Injectable({
    providedIn: 'root'
})
export class NotificationService {
    constructor(
        private translateService: TranslateService,
        private toastr: ToastrService,
        private store: Store<IAuroraState>,
        private ngZone: NgZone
    ) {
    }

    notify(tradKeys: string[], gravity: NotfGravity, type: NotifType, data: any = null) {
        const translations = this.translateService.instant(tradKeys, data);
        const title = translations[tradKeys[0]];
        const message = translations[tradKeys[1]];

        if (type === NotifType.BOTH || type === NotifType.SNACKBAR) {
            this.launchToast(title, message, gravity);
        }


        if (type === NotifType.BOTH || type === NotifType.POPIN) {
            this.addWarning(title, message, gravity);
        }
    }

    private launchToast(title: string, message: string, gravity: NotfGravity) {
        const msg = (message && message.trim()) ? message : (title || ' ');
        this.ngZone.run(() => {
            switch (gravity) {
                case NotfGravity.success:
                    this.toastr.success(msg, title);
                    break;
                case NotfGravity.danger:
                    this.toastr.error(msg, title);
                    break;
                case NotfGravity.warning1:
                case NotfGravity.warning2:
                    this.toastr.warning(msg, title); // was "title"
                    break;
                case NotfGravity.normal:
                default:
                    this.toastr.info(msg, title);
                    break;
            }
        });
    }

    private addWarning(title: string, text: string, gravity: NotfGravity) {
        const message = new Message(
            title,
            text,
            gravity
        );

        this.store.dispatch(fromNotfStore.NotfWarnStoreActions.AddMessage({ message }));
    }
}